import { render, staticRenderFns } from "./Heartbeat.vue?vue&type=template&id=512197c6&scoped=true&"
import script from "./Heartbeat.vue?vue&type=script&lang=js&"
export * from "./Heartbeat.vue?vue&type=script&lang=js&"
import style0 from "./Heartbeat.vue?vue&type=style&index=0&id=512197c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512197c6",
  null
  
)

export default component.exports